import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=7390faba&scoped=true&"
import script from "./tableItem.vue?vue&type=script&lang=js&"
export * from "./tableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390faba",
  null
  
)

export default component.exports